import classNames from "classnames";
import { Icon } from "../icon";
import { IGameSocialLinks } from "./game-social-links.types";

export const GameSocialLinks: IGameSocialLinks = ({ game, className, smallIcons }) => {
  const { apple, steam, google, meta, discord } = game;

  const heighClassName = smallIcons ? "h-[16px] md:h-[18px]" : "md:h-[24px]";
  const gapClassName = smallIcons ? "gap-[16px] md:gap-[26px] mdx:gap-[32px]" : "md:gap-[38px]";

  return (
    <div
      className={classNames("flex flex-row max-[300px]:gap-[15px] gap-[23px] items-center", gapClassName, className)}
    >
      {meta && (
        <Icon
          name="meta"
          link={meta}
          className={heighClassName}
        />
      )}
      {steam && (
        <Icon
          name="steam"
          link={steam}
          className={classNames("ml-[-2px]", heighClassName)}
        />
      )}
      {apple && (
        <Icon
          name="apple"
          link={apple}
          className={classNames("ml-[3px]", heighClassName)}
        />
      )}
      {google && (
        <Icon
          name="googlepay"
          link={google}
          className={classNames("ml-[4px]", heighClassName)}
        />
      )}

      {discord && (
        <Icon
          name="discord"
          link={discord}
          className={classNames("ml-[4px] w-[28px]", heighClassName)}
        />
      )}
    </div>
  );
};
